import React, { useEffect } from 'react'
import ProductPage from './ProductPage'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import Nav from '../Header/Nav'
import WhatssapIcon from '../Home/WhatssapIcon'

const PreviewProduct = () => {

  useEffect(() => {
    // This is more reliable for sticky headers
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
    });
}, []);

  return (
    <div>

        <Header />

        <Nav target="preview" />

        <ProductPage/>

        <WhatssapIcon />

        <Footer />

    </div>
  )
}

export default PreviewProduct